import { render, staticRenderFns } from "./stockin_detail.vue?vue&type=template&id=6524bae2&scoped=true"
import script from "./stockin_detail.vue?vue&type=script&lang=js"
export * from "./stockin_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6524bae2",
  null
  
)

export default component.exports